import React from 'react';
import { C } from '../utils/theme.js';

export default function Card(props) {
  var glow = props.glow;
  var style = Object.assign({}, {
    background: "linear-gradient(135deg," + C.s1 + "," + C.s2 + ")",
    border: "1px solid " + C.bd,
    borderRadius: 12,
    overflow: "hidden"
  }, glow ? { boxShadow: "0 0 20px " + glow + "15" } : {}, props.style || {});
  return React.createElement("div", {
    style: style,
    onClick: props.onClick,
    onDragOver: props.onDragOver,
    onDragLeave: props.onDragLeave,
    onDrop: props.onDrop
  }, props.children);
}
